exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning-wrapper[data-v-3fab342d]{background-color:#fff7de;padding:1rem;border-radius:.3125rem}.warning-wrapper p[data-v-3fab342d],.warning-wrapper strong[data-v-3fab342d]{color:#7e5519}.warning-wrapper p[data-v-3fab342d]{margin:1rem 0 0;line-height:1.5}", ""]);

// exports
